import React from 'react';
import { Popover } from 'antd';
import ReactMarkdown from 'react-markdown';
import { ContactDisplay } from '../types/ContactDisplay';

interface ContactPreviewProps {
  contact: ContactDisplay;
}

// Quick look on hover: number, AI summary and custom tags without opening the drawer
const ContactPreview: React.FC<React.PropsWithChildren<ContactPreviewProps>> = ({ contact, children }) => (
  <Popover
    placement="right"
    arrow={false}
    mouseEnterDelay={0.4}
    content={
      <div className="contacts__preview">
        <div className="contacts__preview-name">{contact.fullName}</div>
        {contact.phone && <div className="contacts__preview-phone">{contact.phone}</div>}
        <div className="contacts__preview-title">Synthèse IA</div>
        {contact.isConfidential ? (
          <p className="contacts__muted">Mode confidentiel : aucune analyse IA.</p>
        ) : contact.summaryMarkdown ? (
          <div className="contacts__preview-summary">
            <ReactMarkdown>{contact.summaryMarkdown}</ReactMarkdown>
          </div>
        ) : (
          <p className="contacts__muted">Pas encore de synthèse.</p>
        )}
        {contact.customTags.length > 0 && (
          <div className="contacts__tags">
            {contact.customTags.map((tag) => (
              <span key={tag.id} className="contacts__tag">
                {tag.name}
              </span>
            ))}
          </div>
        )}
      </div>
    }
  >
    {children}
  </Popover>
);

export default ContactPreview;
